import { ChangeDetectorRef, Component, DOCUMENT, Inject, Renderer2, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { distinctUntilChanged, takeUntil, combineLatest, map, tap, Observable, BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from './auth/services/auth.service';
import { LoadingService } from './services/loading.service';
import { ThemeService } from './services/theme.service';
import { MainLayoutComponent } from './layout/components/main-layout/main-layout';
import { ToastComponent } from './shared/components/toast/toast.component';
import { AsyncPipe, NgIf } from '@angular/common';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MainLayoutComponent, ToastComponent, AsyncPipe, NgIf],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('Ubiquity');
  loading$: Observable<boolean>;
  error$: Observable<boolean>;
  isAuthenticated$: Observable<boolean>;
  showAuthenticatedContent$: Observable<boolean>;
  private destroy$ = new Subject<void>();
  private componentReady$ = new BehaviorSubject<boolean>(false);

  constructor(
    public loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private themeService: ThemeService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.loading$ = this.loadingService.loading$;
    this.error$ = this.loadingService.error$;

    this.isAuthenticated$ = this.authService.isAuthenticated().pipe(
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    );

    this.showAuthenticatedContent$ = combineLatest([
      this.isAuthenticated$,
      this.componentReady$.asObservable()
    ]).pipe(
      map(([authenticated, componentReady]) => authenticated && componentReady),
      distinctUntilChanged(),
      tap(showContent => {
        if (showContent) {
          //this.forceStyleReapplication();
        }
        this.cdr.detectChanges();
      }),
      takeUntil(this.destroy$)
    );
  }

  logout(): void {
    this.authService.logout().subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.componentReady$.complete();
  }
}
